import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Center, Spinner, Text, VStack } from '@chakra-ui/react';

function SlackCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    // The backend will handle the OAuth callback and session creation
    // We just need to check if we're authenticated and redirect accordingly
    const checkAuthStatus = async () => {
      try {
        await refreshUser();
        navigate('/landing');
      } catch (error) {
        console.error('Auth failed:', error);
        navigate('/login');
      }
    };

    checkAuthStatus();
  }, [navigate, refreshUser]);

  return (
    <Center h="100vh" bg="gray.900">
      <VStack spacing={4}>
        <Spinner size="xl" color="white" />
        <Text color="white">Completing sign in...</Text>
        <Text color="gray.400" fontSize="sm">Verifying your Slack account...</Text>
      </VStack>
    </Center>
  );
}

export default SlackCallback;
